// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lp_buttons-module--wrapper--1j3Re","title":"lp_buttons-module--title--jhmtq","buttonsWrapper":"lp_buttons-module--buttonsWrapper--M6Tan"};